import svgUrl from "ni:svgr;MwSzinUtLrguqP65w5uUtH-d3nQskLQuCkPjFNB4nJ4";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiFolderSourceSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="var(--tbl--colors--icons--transformation--primary)" fillRule="evenodd" d="M3 3a2 2 0 0 0-2 2h7l-.724-1.447A1 1 0 0 0 6.382 3H3Zm-2 9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H1v7Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiFolderSourceSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiFolderSourceSIcon)";
}